// Generated from src/assets/BorderedClose.svg
import React, { PureComponent } from "react";

interface ISVGImageFusionIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer",
};

export default class SVGImageFusionIcon extends PureComponent<
  ISVGImageFusionIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;

    return (
      <svg
        {...props}
        className={"only-stroke"}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 35}
        style={style}
        x="0px"
        y="0px"
        width="35px"
        height="35px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <g id="레이어_3">
          <path
            fill="none"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="
		M9.10361,17.50003c0-5.65159,3.5224-10.43701,8.39642-12.11134c-1.20105-0.41256-2.48102-0.64341-3.81427-0.64341
		c-6.74377,0-12.21069,5.7105-12.21069,12.75475s5.46692,12.75468,12.21069,12.75468c1.33325,0,2.61322-0.23086,3.81427-0.64341
		C12.62601,27.93698,9.10361,23.15162,9.10361,17.50003z"
          />
          <path
            fill="none"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            d="
		M21.31424,4.74528c-1.33325,0-2.61316,0.23086-3.81421,0.64341c4.87402,1.67432,8.39636,6.45975,8.39636,12.11134
		s-3.52234,10.43695-8.39636,12.11127c1.20105,0.41256,2.48096,0.64341,3.81421,0.64341
		c6.74377,0,12.21069-5.71044,12.21069-12.75468S28.05801,4.74528,21.31424,4.74528z"
          />
          <g>
            <ellipse cx="17.49665" cy="17.50002" rx="8.39304" ry="12.11132" />
          </g>
          <g>
            <path
              d="M17.39111,27.85484c-4.10205-1.54492-6.84229-5.67676-6.84229-10.35498s2.74023-8.80957,6.84229-10.35449
			c4.10205,1.54492,6.84229,5.67627,6.84229,10.35449S21.49316,26.30992,17.39111,27.85484z"
            />
            <path
              stroke="none"
              fill="#3A3938"
              d="M17.39105,7.81654c3.73672,1.51652,6.217,5.34991,6.217,9.68349c0,4.33354-2.48027,8.16692-6.217,9.68343
			c-3.73676-1.51653-6.21706-5.3499-6.21706-9.68343C11.17399,13.16646,13.6543,9.33307,17.39105,7.81654 M17.39105,6.4804
			c-4.33454,1.5234-7.46706,5.87747-7.46706,11.01963s3.13252,9.49617,7.46706,11.01957
			c4.33454-1.5234,7.467-5.87741,7.467-11.01957S21.72559,8.0038,17.39105,6.4804L17.39105,6.4804z"
            />
          </g>
        </g>
      </svg>
    );
  }
}
